import naja from 'naja';
import { getFilterParams } from './filters';

let currentPage = 0;

function getLoadMoreBtn() {
	return document.querySelector('.load-more');
}

function handleLoadMoreClick() {
	const button = getLoadMoreBtn();
	if (!button || button.disabled) {
		return;
	}

	button.textContent = button.getAttribute('data-text-loading');
	loadPage(currentPage + 1, getFilterParams());
}

export function setupPagination() {
	naja.addEventListener('complete', () => {
		attachLoadMoreListener();
		window.LazyLoad.update();
	});
}

function attachLoadMoreListener() {
	const button = getLoadMoreBtn();
	if (!button) {
		return;
	}

	button.removeEventListener('click', handleLoadMoreClick);
	button.addEventListener('click', handleLoadMoreClick);
}

export function loadPage(page = 0, filters = {}, append = true) {
	const loadMoreBtn = getLoadMoreBtn();
	if (loadMoreBtn) {
		loadMoreBtn.textContent = loadMoreBtn.getAttribute('data-text-loading');
		loadMoreBtn.disabled = true;
	}
	if (!append) {
		document.getElementById('snippet--results').innerHTML = '';
	}

	const queryParams = new URLSearchParams();
	queryParams.append('page', page);
	for (const [key, value] of Object.entries(filters)) {
		if (Array.isArray(value)) {
			value.forEach(val => queryParams.append(`${key}[]`, val));
		} else if (value !== '') {
			queryParams.append(key, value);
		}
	}
	console.log(queryParams.toString());

	naja.makeRequest('GET', `?do=more&${queryParams.toString()}`, null, {
		history: false,
	}).then(payload => {
		if (!payload?.hasMore) {
			getLoadMoreBtn()?.remove();
		}
		const button = getLoadMoreBtn();
		if (button) {
			button.textContent = button.getAttribute('data-text');
			button.disabled = false;
		}
	});

	currentPage = page;
}

export function resetPagination() {
	currentPage = 0;
	const loadMoreBtn = getLoadMoreBtn();
	if (!loadMoreBtn) {
		return;
	}

	loadMoreBtn.style.display = 'inline-block';
	loadMoreBtn.disabled = false;
}
